import type { ReactNode } from "react";
import { Star } from "lucide-react";

interface ReviewRatingProps {
  /** The row around the stars: spacing and alignment. */
  className: string;
  /** The stars' own row. */
  innerClassName: string;
  rating: number;
  /** Each star's size. */
  starClassName: string;
}

const STAR_COUNT = 5,
  STARS = Array.from({ length: STAR_COUNT }, (_star, index) => index + 1),

  fillClass = (star: number, rating: number): string => {
    if (star <= rating) {
      return "jobsite:fill-current";
    }
    return "jobsite:fill-none";
  },

  // Five stars, filled up to the rating.
  ReviewRating = ({ className, innerClassName, rating, starClassName }: ReviewRatingProps): ReactNode => (
    <div className={className}>
      <div className={innerClassName}>
        {STARS.map((star) => (
          <Star key={star} className={`${starClassName} ${fillClass(star, rating)}`} />
        ))}
      </div>
    </div>
  );

export { ReviewRating };
